import React, { useState } from "react";
import { isDuplicate } from "../utils";
import PropTypes from "prop-types";

import {
  Card,
  Divider,
  CardContent,
  Modal,
  TextField,
  Box,
  Button,
  Typography,
} from "@mui/material";

const CreateKeywordModal = (props) => {
  const { keywords, handleClose, handleSubmit, open } = props;

  const [newKeyword, setNewKeyword] = useState("");
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState();

  const handleChange = (keyword) => {
    setNewKeyword(keyword);
    setTouched(true);

    if (keyword.trim() === "") setError("can't be blank");
    else if (isDuplicate(keyword, keywords))
      setError("this keyword already exists");
    else setError("");
  };

  const resetForm = () => {
    setTouched(false);
    setError("");
    setNewKeyword("");
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Card
        data-testid="modal-keyword-create"
        sx={{
          maxWidth: { xs: "90%", sm: "400px", md: "500px" },
          m: "10% auto 0 auto",
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit({ keyword: newKeyword });
            resetForm();
          }}
          autoComplete="false"
          autoCorrect="false"
        >
          <CardContent>
            <Typography variant="h6" sx={{ mb: 2.5 }}>
              Create a Keyword
            </Typography>
            <TextField
              autoFocus
              fullWidth
              error={Boolean(touched && error)}
              helperText={(touched && error) || " "} // the || " " prevents a layout shift
              label="Keyword Name"
              onChange={(e) => handleChange(e.target.value)}
              value={newKeyword}
            />
          </CardContent>
          <Divider />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              p: 2,
            }}
          >
            <Button
              onClick={() => {
                resetForm();
                handleClose();
              }}
              sx={{ mr: 1 }}
            >
              Cancel
            </Button>
            <Button
              color="success"
              variant="contained"
              type="submit"
              disabled={Boolean(!touched || error)}
            >
              Create Keyword
            </Button>
          </Box>
        </form>
      </Card>
    </Modal>
  );
};

CreateKeywordModal.propTypes = {
  open: PropTypes.bool.isRequired,
  keywords: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default CreateKeywordModal;
